import * as S from "../styles";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AutoCompleteMult from "@/components/hookForms/autoCompleteMult";
import { Button } from "@mui/material";
import CheckBox from "../../../../components/hookForms/checkbox";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerMui from "../../../../components/hookForms/datePicker";
import IGenericResult from "../../../../interfaces/IGenericResult";
import IconButton from "@mui/material/IconButton";
import { format } from "date-fns";
import messages from "../../../../utils/messages";
import serviceRelatorio from "../../../../services/serviceRelatorio";
import serviceUsina from "../../../../services/serviceUsina";
import serviceConcessionaria from "../../../../services/serviceConcessionaria";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
}

export default function StatusUsinas({ open, onClose }: IDialogProps) {
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [disabled, setDisabled] = useState(false);

    const history = useHistory();

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            idsUsinas: "",
            idsConcessionarias: "",
            dataInicio: "",
            dataFim: "",
        },
    });

    useEffect(() => {
        setUsinaData();
        setConcessionariaData();
    }, []);

    const setUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };
    
    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    const onSubmit = (values: any) => {
        setDisabled(true);

        let cicloFaturamento = new Date(values.cicloFaturamento);

        const newValues = {
            ...values,
            relatorioTipoID: 3,
            idsUsinas: values.idsUsinas ? values.idsUsinas.join(", ") : "",
            idsConcessionarias: values.idsConcessionarias ? values.idsConcessionarias.join(", ") : "",
            dataInicio: values?.dataInicio ? format(values?.dataInicio, "yyyy-MM-01") : "",
            dataFim: values?.dataFim ? format(values?.dataFim, "yyyy-MM-01") : "",
        };

        delete newValues.redirecionar;

        serviceRelatorio
            .getRelatorioStatusUsina(newValues)
            .then((result) => {
                if (result) {
                    onClose();
                    toast.success(messages.reportSucess);
                }
            })
            .catch(() => {
                toast.error(messages.reportError);
            })
            .finally(() => {
                setDisabled(false);
                if (values.redirecionar) {
                    history.push("/relatorios/listagemrelatorios");
                }
            });
    };

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <S.Title>Gerar relatório: Status de usinas</S.Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            // color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid item xs={12}>
                            {disabled && (
                                <S.Loader>
                                    <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                                </S.Loader>
                            )}
                        </Grid>

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <DatePickerMui
                                    name="dataInicio"
                                    label="Início"
                                    control={control}
                                    error={errors}
                                    format="MM/yyyy"
                                    view={["month", "year"]}
                                    noDateForward
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <DatePickerMui
                                    name="dataFim"
                                    label="Fim"
                                    control={control}
                                    error={errors}
                                    format="MM/yyyy"
                                    view={["month", "year"]}
                                    noDateForward
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="idsConcessionarias"
                                    label="Concessionárias"
                                    options={concessionariaDataOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="idsUsinas"
                                    label="Usinas"
                                    options={usinaDataOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                        <S.Spacing />
                        <Grid item xs={12} md={6}>
                            <CheckBox
                                name="redirecionar"
                                label="Redirecionar para a tela de relatório"
                                control={control}
                                error={errors}
                            />
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {
                                reset();
                                onClose();
                            }}
                            color="warning"
                            variant="contained"
                        >
                            Cancelar
                        </Button>
                        <Button
                            disabled={disabled}
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {}}
                            type="submit"
                            variant="contained"
                        >
                            Gerar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}
